<template>
  <v-card class="carteirinha-card rounded-lg" outlined elevation="2">
    <div
      style="
        padding-bottom: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
      "
    >
      <v-img :src="urlDaImagem" alt="Foto do aluno" class="cartao" style="width: 60%" />
    </div>
    <v-btn
      block
      color="success"
      class="btn-download rounded-lg"
      @click="baixar(data.matricula)"
      :loading="isDownloading"
      :disabled="!urlDaImagem || isDownloading"
    >
      <v-icon left>fa-solid fa-download</v-icon>
      Baixar Carteirinha
    </v-btn>
  </v-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      urlDaImagem: null,
      isDownloading: false,
    };
  },
  watch: {
    "data.matricula": {
      handler(newVal) {
        if (newVal) this.carteleirinhaPerfilImage(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    async carteleirinhaPerfilImage(matricula) {
      try {
        const response = await this.$services.carteirinhaService.cartaoImageBase64(matricula.id);
        this.urlDaImagem = response.imagem_base64;
      } catch (error) {
        this.$handleError(error);
        this.urlDaImagem = null;
      }
    },
    handleImageError() {
      this.urlDaImagem = null;
    },
    async baixar(matricula) {
      this.$loaderService.open("Baixando carteirinha");
      if (!matricula || this.isDownloading) return;
      this.isDownloading = true;
      try {
        await this.$services.carteirinhaService.baixar(matricula);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.isDownloading = false;
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style scoped>
.carteirinha-card {
  margin: 0 auto;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.cartao {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.btn-download {
  border-radius: 8px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.25px;
  height: 48px;
}
</style>
